import { HttpClient } from '@angular/common/http';
import {AfterContentInit, Component, ElementRef, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit {
  apply_as: string = 'rep';
  referenceFile: any;
  constructor(private router: Router, private http: HttpClient) { }
  ngOnInit() {
    this.onLoadReferenceFile()
  }
  onRequestService() {
    switch (this.apply_as) {
      case 'rep':
          this.router.navigate(['/create']);
          break;
      case 'contractor':
          window.open(this.referenceFile.urls.contractor, '_self', 'noopener');
          break;
      case 'cbm':
          window.open(this.referenceFile.urls.contractorCBM, '_self', 'noopener');
          break;
      default:
         this.router.navigate(['/create']);
    }
  }

  onLoadReferenceFile() {
      this.http.get(`/assets/json/reference-text.json`).subscribe({
        next: (data) => {
          this.referenceFile = data
        },
    })
  }
}
